if (!customElements.get('custom-select')) {
  customElements.define(
    'custom-select',
    class CustomSelect extends HTMLElement {
      constructor() {
        super();
        this.handleClickItem = this.handleClickItem.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.hideSelectedItem = this.hideSelectedItem.bind(this);
        this.summaryText = this.querySelector('.custom-select__text');
        this.triggerBtn = this.querySelector('.custom-select__trigger');
        this.list = this.querySelector('ul');
        this.listItems = this.list.querySelectorAll('li');
        this.prefersReducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)',
        );

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onClickTrigger = this.onClickTrigger.bind(this);
      }

      connectedCallback() {
        this.bindEvents();
        this.hideSelectedItem();
      }

      disconnectedCallback() {
        this.unbindEvents();
      }

      bindEvents() {
        this.triggerBtn.addEventListener('click', this.onClickTrigger);
        this.addEventListener('focusout', this.onFocusOut);
        this.addEventListener('keyup', this.onKeyUp);
        this.listItems.forEach(item => {
          item.tabIndex = 0;
          item.addEventListener('click', this.handleClickItem);
        });
        this.addEventListener('keydown', this.handleKeydown);
      }

      unbindEvents() {
        this.triggerBtn.removeEventListener('click', this.open);
        this.removeEventListener('focusout', this.onFocusOut);
        this.removeEventListener('keyup', this.onKeyUp);
        this.listItems.forEach(item => {
          item.removeEventListener('click', this.handleClickItem);
        });
        this.removeEventListener('keydown', this.handleKeydown);
      }

      isOpen() {
        return this.hasAttribute('open');
      }

      onClickTrigger(e) {
        e.preventDefault();
        this.isOpen() ? this.close() : this.open();
      }

      onFocusOut() {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }

      onKeyUp(e) {
        if (e.key === 'Escape') {
          this.close();
        }
      }

      hideSelectedItem() {
        const selectedText = this.summaryText.textContent.trim();
        this.listItems.forEach(item => {
          if (item.textContent.trim() === selectedText) {
            item.style.display = 'none';
          } else {
            item.style.display = '';
          }
        });
      }

      handleKeydown(e) {
        if (e.target.matches('li')) {
          if (e.key === ' ' || e.key === 'Enter') {
            this.handleClickItem(e);
          }
        }
      }

      open() {
        gsap.set(this.list, {
          display: 'block',
          scaleY: 0,
          opacity: 0,
          transformOrigin: 'top',
        });

        const duration = this.prefersReducedMotion.matches ? 0 : 0.3;

        gsap.to(this.list, {
          scaleY: 1,
          opacity: 1,
          delay: 0.01,
          duration,
        });
        this.triggerBtn.setAttribute('aria-expanded', 'true');

        this.setAttribute('open', 'true');
        setTimeout(() => {
          this.focusFirstVisibleItem();
        });
      }

      close() {
        this.classList.add('is-closing');
        this.triggerBtn.setAttribute('aria-expanded', 'false');

        const duration = this.prefersReducedMotion.matches ? 0 : 0.18;
        gsap.to(this.list, {
          scaleY: 0,
          duration,
          display: 'none',
          onComplete: () => {
            this.classList.remove('is-closing');
          },
        });

        this.removeAttribute('open');
      }

      focusFirstVisibleItem() {
        const items = this.querySelectorAll('li');
        for (const item of items) {
          if (item.style.display !== 'none') {
            item.focus();
            break;
          }
        }
      }

      handleClickItem(e) {
        let refocus = false;
        const value = e.target.innerText.trim();
        this.summaryText.innerText = value;

        if (document.activeElement.matches('li')) {
          refocus = true;
        }

        this.close();
        this.hideSelectedItem();

        const index = Array.from(this.list.children).indexOf(e.target);

        this.dispatchEvent(
          new CustomEvent('change', {
            bubbles: true,
            detail: {
              selectedValue: value,
              selectedIndex: index,
            },
          }),
        );

        window.setTimeout(() => {
          this.triggerBtn.focus();
        });
      }
    },
  );
}
